import router from '../router';
import store from '../store';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { setLocal, getToken } from '@/utils/storage.js';
// http://192.168.14.202:8081/#/distributor?action=notice&openId=pengzukang&params=1_1101147485864333312&id=1099625964993908736&token=eyJhbGciOiJIUzI1NiIsIlR5cGUiOiJKd3QiLCJ0eXAiOiJKV1QifQ.eyJsb2dpblRpbWUiOiIyMDIzLTA1LTA1IDE3OjMxOjI4IiwibG9naW5UeXBlIjoiMiIsImV4cCI6MTY4MzI5MzQ4OCwidXNlcklkIjoiMTA5OTYyNTk2NDk5MzkwODczNiJ9.mJ1o8-bWasu67Dor_km5XNn4pc1MIH0iz_r-DyhljQk
// http://192.168.14.202:8081/#/distributor?action=login&openId=pengzukang&source=school
// http://192.168.14.202:8081/#/distributor?action=login&openId=pengzukang&source=subject
// http://192.168.14.202:8080/#/distributor?action=home&openId=ZhouYuYong&source=school&id=1092455779606335488
const whiteList = ['login']; // 白名单
router.beforeEach((to, from, next) => {
  NProgress.start(); // 使用NProgress
  if (to.name === 'Distributor') {
    let pageType = '';
    let pageParamsVal = '';
    if (to.query.params) {
      const params = to.query.params;
      pageType = params.charAt(0);// 获取页面跳转类型 1：'视导通知'2：'常规视导专家分配通知'3：'视导报告通知'
      pageParamsVal = params.slice(2);
    }
    const qwInfo = {
      source: to.query.source,
      openId: to.query.openId,
      pageType: pageType,
      pageParamsVal: pageParamsVal,
      action: to.query.action
    };
    setLocal('qwInfo', qwInfo);
    if (to.query.token) {
      store.commit('SET_TOKEN', to.query.token);
      const userId = to.query.id;
      store.dispatch('GetUserInfo', userId).then(res => {
        store.dispatch('JumpPageBasedConditions', qwInfo);
      });
    } else {
      store.dispatch('FedLogOut').then(() => {
        next({ path: '/login', replace: true });
      });
    }
    next();
  } else if (getToken()) {
    next();
  } else {
    if (whiteList.indexOf(to.name) !== -1) {
      next();
    } else {
      store.dispatch('FedLogOut').then(() => {
        // next(`/login?redirect=${to.path}`);
        window.location.replace(`${window.location.origin}/index.html/login`);
      });
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // 结束Progress
});
